import Image from '@atoms/Image/Image';
import { IImage } from '@models/IImage';
import PaginationCarousel from '@molecules/PaginationCarousel/PaginationCarousel';
import useMediaQuery from '@utils/hooks/useMediaQuery';
import classNames from 'classnames';
import { SwiperSlide } from 'swiper/react';
import ProductDetailsGalleryDesktop from './ProductDetailsGalleryDesktop';

interface Props {
  readonly productImages: [IImage, ...IImage[]];
}

const ProductDetailsGallery = ({ productImages }: Props) => {
  const isMobile = useMediaQuery(1024);

  return (
    <>
      {isMobile === false && (
        <ProductDetailsGalleryDesktop productImages={productImages} />
      )}

      <div
        className="lg:hidden"
        data-testid="CT-15-Product-Details-Gallery-Mobile"
      >
        <div className="rounded-[10px] bg-grey-100 pb-7.5">
          <PaginationCarousel
            paginationClasses={classNames({
              hidden: productImages.length < 2,
            })}
            customPaginationId="product-images-pagination-carousel"
          >
            {productImages.map((image, index) => (
              <SwiperSlide
                key={`product-details-image-${image.desktop?.url}`}
                className="stretch-card"
              >
                <div className="px-2.5 pt-[46px] pb-5">
                  <Image
                    image={image}
                    imageClasses="w-full object-contain h-[210px] md:h-[490px] lg:h-[770px]"
                    dataTestId={`CT-15-Product-Details-Gallery-Mobile-Product-Image-${index}`}
                  />
                </div>
              </SwiperSlide>
            ))}
          </PaginationCarousel>
        </div>
      </div>
    </>
  );
};

export default ProductDetailsGallery;
